import Index from './components/Index.vue';
import Category from "./components/Category.vue";
import Collection from './components/Collection.vue';
import MagicCollection from './components/MagicCollection.vue';
import StoryCollection from './components/StoryCollection.vue';
import Update from './components/Update.vue';
import Daily from './components/Daily.vue';
import Carousel from "./components/Carousel.vue";
import Suspend from './components/Suspend.vue';
import Popup from './components/Popup.vue';
import MagicCover from "./components/MagicCover.vue";
import Avatar from './components/Avatar.vue';
import Score from './components/Score.vue';
import Metric from './components/Metric.vue';
import CountryHot from './components/CountryHot.vue';
import CountryRookie from './components/CountryRookie.vue';
import CountryManual from './components/CountryManual.vue';
import IAP from './components/IAP.vue';
import Subscription from './components/Subscription.vue';
import FindDifference from "./components/FindDifference.vue";
import FindDifferenceImage from "./components/FindDifferenceImage.vue";
import CollectionSort from "./components/CollectionSort.vue";
import NewbieSales from "./components/NewbieSales.vue";
import Match from "./components/Match.vue";
import LibraryRecommend from "./components/LibraryRecommend.vue";
import RecommendFrequency from "./components/RecommendFrequency.vue";
import TranssionImage from "./components/transsion/Image.vue";
import TranssionRookie from "./components/transsion/Rookie.vue";
import TranssionPerformance from "./components/transsion/Performance.vue";
import TranssionUpdate from "./components/transsion/Update.vue";
import TranssionCategory from "./components/transsion/Category.vue";
import Game from "./components/Game.vue";
import GameTask from "./components/GameTask.vue";
import JPScore from "./components/JPScore.vue";
import Tag from "./components/Tag.vue";
import ClassicImport from "./components/ClassicImport.vue";
import AppManagement from "./components/AppManagement.vue";
import WeeklyReport from "./components/WeeklyReport.vue";
import AchievementConfig from "./components/AchievementConfig.vue";
import AiTagFeedback from "./components/AiTagFeedback.vue";


export const routes = [
    {
        name: 'Index',
        path: '/',
        component: Index,
    }, {
        name: 'Category',
        path: '/category',
        component: Category,
    }, {
        name: 'Collection',
        path: '/collection',
        component: Collection,
    }, {
        name: 'MagicCollection',
        path: '/magic-collection',
        component: MagicCollection,
    }, {
        name: 'StoryCollection',
        path: '/story-collection',
        component: StoryCollection,
    }, {
        name: 'Update',
        path: '/update',
        component: Update,
    }, {
        name: 'Daily',
        path: '/daily',
        component: Daily,
    }, {
        name: 'Carousel',
        path: '/carousel',
        component: Carousel,
    }, {
        name: 'Popup',
        path: '/popup',
        component: Popup
    }, {
        name: 'Suspend',
        path: '/suspend',
        component: Suspend,
    }, {
        name: 'MagicCover',
        path: '/magic',
        component: MagicCover,
    }, {
        name: 'Avatar',
        path: '/avatar',
        component: Avatar,
    }, {
        name: 'Score',
        path: '/score',
        component: Score,
    }, {
        name: 'Metric',
        path: '/metric',
        component: Metric,
    }, {
        name: 'WeeklyReport',
        path: '/weekly-report',
        component: WeeklyReport,
    }, {
        name: 'CountryHot',
        path: '/country/hot',
        component: CountryHot,
    }, {
        name: 'CountryRookie',
        path: '/country/rookie',
        component: CountryRookie,
    },     {
        name: 'CountryManual',
        path: '/country/manual',
        component: CountryManual,
    }, {
        path: '/country/manual-ad-from',
        redirect: (to) => ({ path: '/country/manual', query: to.query }),
    }, {
        name: 'IAP',
        path: '/iap',
        component: IAP,
    }, {
        name: 'Subscription',
        path: '/subscription',
        component: Subscription,
    }, {
        name: 'NewbieSales',
        path: '/newbie-sales',
        component: NewbieSales,
    }, {
        name: 'FindDifference',
        path: '/find-difference',
        component: FindDifference,
    }, {
        name: 'FindDifferenceImage',
        path: '/find-difference-image',
        component: FindDifferenceImage,
    }, {
        name: 'CollectionSort',
        path: '/collection-sort',
        component: CollectionSort,
    }, {
        name: 'Match',
        path: '/match',
        component: Match,
    }, {
        name: 'LibraryRecommend',
        path: '/library-recommend',
        component: LibraryRecommend,
    }, {
        name: 'RecommendFrequency',
        path: '/recommend-frequency',
        component: RecommendFrequency,
    }, {
        name: 'TranssionImage',
        path: '/transsion-image',
        component: TranssionImage,
    }, {
        name: 'TranssionPerformance',
        path: '/transsion-performance',
        component: TranssionPerformance,
    }, {
        name: 'TranssionRookie',
        path: '/transsion-rookie',
        component: TranssionRookie,
    }, {
        name: 'TranssionUpdate',
        path: '/transsion-update',
        component: TranssionUpdate,
    }, {
        name: 'TranssionCategory',
        path: '/transsion-category',
        component: TranssionCategory,
    }, {
        name: 'Game',
        path: '/game',
        component: Game,
    }, {
        name: 'GameTask',
        path: '/game-task',
        component: GameTask,
    }, {
        name: 'JPScore',
        path: '/jp-score',
        component: JPScore,
    }, {
        name: 'Tag',
        path: '/tag',
        component: Tag,
    }, {
        name: 'AiTagFeedback',
        path: '/ai-tag-feedback',
        component: AiTagFeedback,
    }, {
        name: 'ClassicImport',
        path: '/classic-import',
        component: ClassicImport,
    }, {
        name: 'AppManagement',
        path: '/app-management',
        component: AppManagement,
    }, {
        name: 'AchievementConfig',
        path: '/achievement',
        component: AchievementConfig,
    },
]
